import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchSetupLists(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('budget/budget', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
